import { useGeneralHook } from "api/hooks/allHooks";
import { energyAnalysisCacheKeys } from "features/energy-analysis-dashboard/api/cacheKeys";

import type { CrremDashboardPayload } from "../model/types";

import { fetchCrremDashboardScenarios } from "../api/callers";

export const useCrremDashboardScenarios = (projectId: string) =>
  useGeneralHook<CrremDashboardPayload>(
    energyAnalysisCacheKeys.allScenarios(projectId),
    () => fetchCrremDashboardScenarios(projectId),
    { enabled: Boolean(projectId), refetchOnMount: false, retry: false }
  );
